import { get } from "lodash";
import { isContainedInList, defaultBooleanField, defaultField } from "helpers/row-logic-helper";
import { PREPAYMENT_TYPES } from "@loanbossinc/component-library";

export const shouldShowParPrepaymentPeriod = data => Boolean(get(data, "prepaymentTerms.parPrepaymentPeriod")) && isContainedInList(data, "prepaymentTerms.prepaymentTypeId", [
  PREPAYMENT_TYPES.YIELD_MAINTENANCE,
  PREPAYMENT_TYPES.YIELD_MAINTENANCE_AGENCY,
  PREPAYMENT_TYPES.LOCKOUT,
  PREPAYMENT_TYPES.MAKE_WHOLE,
  PREPAYMENT_TYPES.FLAT_PERCENTAGE,
  PREPAYMENT_TYPES.DEFEASANCE,
  PREPAYMENT_TYPES.SPREAD_MAINTENANCE,
  PREPAYMENT_TYPES.AGGREGATE_INTEREST
]);

export const shouldShowParPrepaymentPeriodEdit = data => isContainedInList(data, "prepaymentTerms.prepaymentTypeId", [
  PREPAYMENT_TYPES.YIELD_MAINTENANCE,
  PREPAYMENT_TYPES.YIELD_MAINTENANCE_AGENCY,
  PREPAYMENT_TYPES.LOCKOUT,
  PREPAYMENT_TYPES.MAKE_WHOLE,
  PREPAYMENT_TYPES.FLAT_PERCENTAGE,
  PREPAYMENT_TYPES.DEFEASANCE,
  PREPAYMENT_TYPES.SPREAD_MAINTENANCE,
  PREPAYMENT_TYPES.AGGREGATE_INTEREST
]);

export const shouldShowSpreadMaintenancePeriod = data => Boolean(get(data, "prepaymentTerms.spreadMaintenance")) && isContainedInList(data, "prepaymentTerms.prepaymentTypeId", [
  PREPAYMENT_TYPES.SPREAD_MAINTENANCE
]);

export const shouldShowSpreadMaintenancePeriodEdit = data => isContainedInList(data, "prepaymentTerms.prepaymentTypeId", [
  PREPAYMENT_TYPES.SPREAD_MAINTENANCE
]);

export const shouldShowYieldMaintenancePeriod = data => Boolean(get(data, "prepaymentTerms.yieldMaintenancePeriod")) && isContainedInList(data, "prepaymentTerms.prepaymentTypeId", [
  PREPAYMENT_TYPES.YIELD_MAINTENANCE,
  PREPAYMENT_TYPES.YIELD_MAINTENANCE_AGENCY
]);

export const shouldShowYieldMaintenancePeriodEdit = data => isContainedInList(data, "prepaymentTerms.prepaymentTypeId", [
  PREPAYMENT_TYPES.YIELD_MAINTENANCE,
  PREPAYMENT_TYPES.YIELD_MAINTENANCE_AGENCY
]);

export const shouldShowMakeWholePeriod = data => Boolean(get(data, "prepaymentTerms.makeWholePeriod")) && isContainedInList(data, "prepaymentTerms.prepaymentTypeId", [
  PREPAYMENT_TYPES.MAKE_WHOLE
]);

export const shouldShowMakeWholePeriodEdit = data => isContainedInList(data, "prepaymentTerms.prepaymentTypeId", [
  PREPAYMENT_TYPES.MAKE_WHOLE
]);

export const shouldShowSuccessorBorrowerDesignation = data => Boolean(get(data, "prepaymentTerms.successorBorrowerDesignation")) && isContainedInList(data, "prepaymentTerms.prepaymentTypeId", [
  PREPAYMENT_TYPES.DEFEASANCE
]);

export const shouldShowSuccessorBorrowerDesignationEdit = data => isContainedInList(data, "prepaymentTerms.prepaymentTypeId", [
  PREPAYMENT_TYPES.DEFEASANCE
]);

export const shouldShowCalculationMethodology = data => Boolean(get(data, "prepaymentTerms.calculationMethodology")) && isContainedInList(data, "prepaymentTerms.prepaymentTypeId", [
  PREPAYMENT_TYPES.YIELD_MAINTENANCE,
  PREPAYMENT_TYPES.YIELD_MAINTENANCE_AGENCY,
  PREPAYMENT_TYPES.LOCKOUT,
  PREPAYMENT_TYPES.MAKE_WHOLE,
  PREPAYMENT_TYPES.FLAT_PERCENTAGE,
  PREPAYMENT_TYPES.SPREAD_MAINTENANCE,
  PREPAYMENT_TYPES.AGGREGATE_INTEREST
]);

export const shouldShowCalculationMethodologyEdit = data => isContainedInList(data, "prepaymentTerms.prepaymentTypeId", [
  PREPAYMENT_TYPES.YIELD_MAINTENANCE,
  PREPAYMENT_TYPES.YIELD_MAINTENANCE_AGENCY,
  PREPAYMENT_TYPES.LOCKOUT,
  PREPAYMENT_TYPES.MAKE_WHOLE,
  PREPAYMENT_TYPES.FLAT_PERCENTAGE,
  PREPAYMENT_TYPES.SPREAD_MAINTENANCE,
  PREPAYMENT_TYPES.AGGREGATE_INTEREST
]);

export const shouldShowReinvestmentRateAssumptions = data => Boolean(get(data, "prepaymentTerms.reinvestmentRateAssumption")) && isContainedInList(data, "prepaymentTerms.prepaymentTypeId", [
  PREPAYMENT_TYPES.YIELD_MAINTENANCE,
  PREPAYMENT_TYPES.YIELD_MAINTENANCE_AGENCY
]);

export const shouldShowReinvestmentRateAssumptionsEdit = data => isContainedInList(data, "prepaymentTerms.prepaymentTypeId", [
  PREPAYMENT_TYPES.YIELD_MAINTENANCE,
  PREPAYMENT_TYPES.YIELD_MAINTENANCE_AGENCY
]);

export const shouldShowPVRateAssumptions = data => Boolean(get(data, "prepaymentTerms.pvRateAssumption")) && isContainedInList(data, "prepaymentTerms.prepaymentTypeId", [
  PREPAYMENT_TYPES.MAKE_WHOLE
]);

export const shouldShowPVRateAssumptionsEdit = data => isContainedInList(data, "prepaymentTerms.prepaymentTypeId", [
  PREPAYMENT_TYPES.MAKE_WHOLE
]);

export const shouldShowDefeasanceCollateral = data => Boolean(get(data, "prepaymentTerms.defeasanceCollateral")) && isContainedInList(data, "prepaymentTerms.prepaymentTypeId", [
  PREPAYMENT_TYPES.DEFEASANCE
]);

export const shouldShowDefeasanceCollateralEdit = data => isContainedInList(data, "prepaymentTerms.prepaymentTypeId", [
  PREPAYMENT_TYPES.DEFEASANCE
]);

export const shouldShowSecuritiesStructure = data => Boolean(get(data, "prepaymentTerms.securitiesStructure")) && isContainedInList(data, "prepaymentTerms.prepaymentTypeId", [
  PREPAYMENT_TYPES.DEFEASANCE
]);

export const shouldShowSecuritiesStructureEdit = data => isContainedInList(data, "prepaymentTerms.prepaymentTypeId", [
  PREPAYMENT_TYPES.DEFEASANCE
]);

export const shouldShowPortfolioMaturity = data => Boolean(get(data, "prepaymentTerms.portfolioMaturity")) && isContainedInList(data, "prepaymentTerms.prepaymentTypeId", [
  PREPAYMENT_TYPES.DEFEASANCE
]);

export const shouldShowPortfolioMaturityEdit = data => isContainedInList(data, "prepaymentTerms.prepaymentTypeId", [
  PREPAYMENT_TYPES.DEFEASANCE
]);

export const shouldShowDefeasanceFee = data => Boolean(get(data, "prepaymentTerms.defeasanceFee")) && isContainedInList(data, "prepaymentTerms.prepaymentTypeId", [
  PREPAYMENT_TYPES.DEFEASANCE
]);

export const shouldShowDefeasanceFeeEdit = data => isContainedInList(data, "prepaymentTerms.prepaymentTypeId", [
  PREPAYMENT_TYPES.DEFEASANCE
]);

export const shouldShowSecuritization = data => Boolean(get(data, "prepaymentTerms.isSecuritized")) && isContainedInList(data, "prepaymentTerms.prepaymentTypeId", [
  PREPAYMENT_TYPES.YIELD_MAINTENANCE,
  PREPAYMENT_TYPES.YIELD_MAINTENANCE_AGENCY,
  PREPAYMENT_TYPES.LOCKOUT,
  PREPAYMENT_TYPES.MAKE_WHOLE,
  PREPAYMENT_TYPES.FLAT_PERCENTAGE,
  PREPAYMENT_TYPES.DEFEASANCE,
  PREPAYMENT_TYPES.SPREAD_MAINTENANCE,
  PREPAYMENT_TYPES.AGGREGATE_INTEREST
]);

export const shouldShowSecuritizationEdit = data => isContainedInList(data, "prepaymentTerms.prepaymentTypeId", [
  PREPAYMENT_TYPES.YIELD_MAINTENANCE,
  PREPAYMENT_TYPES.YIELD_MAINTENANCE_AGENCY,
  PREPAYMENT_TYPES.LOCKOUT,
  PREPAYMENT_TYPES.MAKE_WHOLE,
  PREPAYMENT_TYPES.FLAT_PERCENTAGE,
  PREPAYMENT_TYPES.DEFEASANCE,
  PREPAYMENT_TYPES.SPREAD_MAINTENANCE,
  PREPAYMENT_TYPES.AGGREGATE_INTEREST
]);

export const shouldShowOther = data => Boolean(get(data, "prepaymentTerms.other")) && isContainedInList(data, "prepaymentTerms.prepaymentTypeId", [
  PREPAYMENT_TYPES.YIELD_MAINTENANCE,
  PREPAYMENT_TYPES.YIELD_MAINTENANCE_AGENCY,
  PREPAYMENT_TYPES.LOCKOUT,
  PREPAYMENT_TYPES.MAKE_WHOLE,
  PREPAYMENT_TYPES.FLAT_PERCENTAGE,
  PREPAYMENT_TYPES.DEFEASANCE,
  PREPAYMENT_TYPES.SPREAD_MAINTENANCE,
  PREPAYMENT_TYPES.AGGREGATE_INTEREST,
  PREPAYMENT_TYPES.NONE
]);

export const shouldShowOtherEdit = data => isContainedInList(data, "prepaymentTerms.prepaymentTypeId", [
  PREPAYMENT_TYPES.YIELD_MAINTENANCE,
  PREPAYMENT_TYPES.YIELD_MAINTENANCE_AGENCY,
  PREPAYMENT_TYPES.LOCKOUT,
  PREPAYMENT_TYPES.MAKE_WHOLE,
  PREPAYMENT_TYPES.FLAT_PERCENTAGE,
  PREPAYMENT_TYPES.DEFEASANCE,
  PREPAYMENT_TYPES.SPREAD_MAINTENANCE,
  PREPAYMENT_TYPES.AGGREGATE_INTEREST,
  PREPAYMENT_TYPES.NONE
]);

export const shouldShowSecuritizationDate = data => {
  const isSecuritized = defaultBooleanField(data, "prepaymentTerms.isSecuritized");
  if (isSecuritized === "--") {
    return false;
  }

  return isSecuritized;
};

export const shouldShowPrepaymentType = data => Boolean(get(data, "prepaymentTerms.prepaymentType"));

export const shouldShowExitFee = data => Boolean(get(data, "prepaymentTerms.exitFee"));

export const shouldShowLockoutPeriod = data => Boolean(get(data, "prepaymentTerms.lockoutPeriod"));

export const shouldShowNoticePeriod = data => Boolean(get(data, "prepaymentTerms.noticePeriod"));
